//source https://github.com/stefangabos/world_countries/tree/master/data

const countries = require('./countries.json')
export default countries

